import React from 'react';
import { Row, Col } from 'reactstrap';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import infoIcon from '../../images/info-icon.svg';
import rightArrow from '../../images/right-arrow-head.svg';
import closeIcon from '../../images/close-icon.svg';
import {setVal, changeValue, setMarketSelected} from '../../actions';

class MarketsTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {toggleIcon : false};
    }

    showIcons()
    {
        return this.state.toggleIcon ? '#{rentrackerappimages}#' +'/close-icon.svg' : '#{rentrackerappimages}#' +'/info-icon.svg';
    }
    componentWillReceiveProps(nextProps)
    {  
        this.setState({
          toggleIcon: nextProps.toggleIcon
      });
    }

    toggleDefinition(position)
    {
       this.setState({toggleIcon: !this.state.toggleIcon});
    }

      displayDefinition(position)
      {
        let positionDefinitions = [
            {position: 1, definition: "Rents have reached a peak plateau. Marginal further growth is still possible, while a significant decline is not yet expected. "},
            {position: 2, definition: "Rents are falling and the rate of decline is expected to accelerate over the next six to 12 months."},
            {position: 3, definition: "The rate of rent decline has slowed from the past six to 12 months. Rents have not yet bottomed out and are expected to decline at a slower rate"},
            {position: 4, definition: "Rents are at their trough and the next movement is expected to be an increase."},
            {position: 5, definition: "Rents are rising and the rate of increase is expected to accelerate over the next six to 12 months. "},
            {position: 6, definition: "The rate of rent growth has slowed from the past six to 12 months. Rents have not yet peaked and are expected to increase at a slower rate."} 
           ];

        let found = positionDefinitions.filter(function (item) { return item.position === position; });
       
        let definition = (found[0] ? found[0].definition : position);

        return definition;

      }

      fetchMarketInfo(market){
        market = market.trim();
        let region = '';
        let greaterRegion = '';

        this.props.markets.find((x) => {
            if (x.market === market){
                region = x.region.trim()
                greaterRegion = x.greaterRegion.trim()
            }
            return null;
        })

        this.props.setMarketSelected({greaterRegion, region, market});
    }

        //async
    OnMarketClick(e) {

        let position = this.props.position;

        //let marketbg = document.getElementById('Market-Info-background');
        let marketbg = document.getElementById('Market-Info');

        if(marketbg)
        {
        marketbg.setAttribute("fill", this.props.sectorColor);
        }
       //setting 10 as id for showing Market details in the center
       let currentSelectedMarket = e;
       let updatedSelection=10;
       let updatedWheelPosition;
     
       if(currentSelectedMarket.trim() === this.props.marketselected.trim() )
       {
         updatedSelection = parseInt(position);
         currentSelectedMarket='';
         updatedWheelPosition = parseInt(position)
       }
       else
       {
         updatedSelection = 10;
         currentSelectedMarket =e;
         updatedWheelPosition = parseInt(position)
       }

       this.props.setMarket(currentSelectedMarket, position);
       this.props.setVal(updatedSelection, updatedWheelPosition);

        this.fetchMarketInfo(e);
      }

    render() {
        const { citiesList } = this.props;
        let rowCount;
        if(citiesList && citiesList.length > 0) {
           rowCount = Math.ceil(citiesList.length / 3);
        }
        return (
            <Row className="marketTableWholeContent">
                {this.props.citiesList === null ?
                    <Col style = {{ marginTop: '20px'}} className="mobile-or-tablet-text-box">
                        <p className="market-definitions">Tap on a cycle position to see the markets at that position or search for a market above.</p>
                    </Col> :
                    this.props.citiesList.length === 0 ? // Need to show this again when we unclik the sector
                        <Col className="mobile-or-tablet-text-box">
                                <p className="market-table-head"> 
                                    {this.props.sectorText} 
                                    <img className ="info-icon-mobile"  src={this.showIcons() } alt=""  onClick= {() => this.toggleDefinition(this.props.position)} /> 
                                </p>
                                { 
                                            this.state.toggleIcon ? 
                                            (
                                                <p className="market-definitions" >                                              
                                                    {
                                                        this.displayDefinition(this.props.position)
                                                    }
                                                            
                                                </p>
                                            ):
                                                                                                               
                                            <p className="market-definitions">No {this.props.selectedRegion} markets at this position in {this.props.activeperiod}. </p>
                                }          
                                 
                        </Col>
                        : (
                            <div className="market-table">
                                <p className="market-table-head"> 
                                    {this.props.sectorText} 
                                    <img className ="info-icon-mobile"  src={this.showIcons()} alt=""  onClick= {() => this.toggleDefinition(this.props.position)} />
                                </p>                                    
                                { 
                                        this.state.toggleIcon ? 
                                        (
                                            <p className="market-definitions" style={{ padding:'20px 13px 20px 13px' , fontSize: '12px'}}>                                                            
                                                {
                                                    this.displayDefinition(this.props.position)

                                                }
                                                            
                                            </p>
                                        ):
                                        <ul className="market-table-body" >
                                                {this.props.citiesList.map((eachCity, index) => {
                                                    let selectedColor =  this.props.marketselected.trim() === eachCity.market.trim() ? 'black': this.props.sectorColor;
                                                                  return <li id={eachCity.market} key={index} className={`each-market-col ${Math.ceil((index + 1) / 3) === rowCount ? 'last-row' : ''}`} onClick={()=>this.OnMarketClick(eachCity.market)}>
                                                                            <Link to={`${this.props.basepath}/marketdetailmobile?market=${eachCity.market}`} >
                                                                                <div className="market-table-cell-mobile" >
                                                                            <p>{eachCity.market}</p>
                                                                            <img id="right-arrow-symbol" alt="right-arrow" src={'#{rentrackerappimages}#' +'/right-arrow-head.svg'} onClick={()=>this.OnMarketClick(eachCity.market)}/>
                                                                            </div>
                                                                            </Link>
                                                                        </li>
                                                              })}
                                                               {this.props.citiesList.length % 3 === 1 && 
                                                                        <li className="empty-market-col"></li>
                                                               }                        
                                        </ul>                                                                      
                                                          
                                } 
                                </div>
                           
                          ) 
                }
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeperiod: state.activePeriod,
        selectedRegion: state.greaterRegions,
        marketselected: state.marketselected,
        markets: state.markets,
        basepath : state.basepath
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      setMarket: (marketid, positionid) => {
        dispatch(changeValue(marketid, positionid))
      },
      setVal: (selectedDefinition, selectedPosition ) => {
        dispatch(setVal(selectedDefinition, selectedPosition))
      },
        setMarketSelected: (selection) => dispatch(setMarketSelected(selection))
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MarketsTable);
